import React, { useEffect, useState } from 'react';
import { OpPage } from 'components/customAntd/OpPage/OpPage';
import EmailTemplatesTable from './EmailTemplatesTable';
import { EmailTemplate } from 'types/emailTemplateTypes';
import EmailTemplateDrawer from './EmailTemplatesDrawer';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import { fetchEmailTemplates } from 'store/slices/emailTemplatesSlice';
import { useTranslation } from 'react-i18next';

const EmailTemplates: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const orgId = useSelector((state: RootState) => state.globalOrg.globalOrgId);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState<EmailTemplate | null>(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (orgId) {
      dispatch(fetchEmailTemplates({ orgId }));
    }
  }, [dispatch, orgId]);

  const handleAddClick = () => {
    setSelectedTemplate(null);
    setDrawerVisible(true);
  };

  const handleEditClick = (template: EmailTemplate) => {
    setSelectedTemplate(template);
    setDrawerVisible(true);
  };

  const handleDrawerClose = () => {
    setDrawerVisible(false);
    setSelectedTemplate(null);
  };

  return (
    <OpPage title={t('emailTemplates.title')} tooltip={t('emailTemplates.tooltip')}>
      <EmailTemplatesTable
        handleAddClick={handleAddClick}
        handleEditClick={handleEditClick}
      />

      <EmailTemplateDrawer
        open={drawerVisible}
        onClose={handleDrawerClose}
        selectedTemplate={selectedTemplate}
      />
    </OpPage>
  );
};

export default EmailTemplates;